import React from "react";
import {
  Container,
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  Button
} from "shards-react";

import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import TableRow from '../layout/TableRow';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Modal from "react-bootstrap/Modal";
import { FcAcceptDatabase, FcPlus, FcDownload } from "react-icons/fc";
import SupplierDataService from "../../services/supplier.service";
import { TiDeleteOutline } from "react-icons/ti";
import {  ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import file from "../../SupplierDataSample.xlsx";
import nav_store, {
  types as nav_types,
  actions as nav_actions,
} from "../../_stores/sidenav.store";
import {actions as AppActions} from "../../_stores/app.store";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const INDIA = process.env.REACT_APP_MARKET === "INDIA";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
};

class CreateProjectSupplierConfig extends React.Component {
  constructor(props) {
    super(props);

     this.state = {
       supplierName:"",
       supplierCode:"",
       dsCode:"",
       supplierERP: "",
       supplierAddress:"",
       supplierCity:"",
       supplierState:"",
       supplierZone:"",
      // supplierGST: "",
       supplierFileLocation: false,
       supplierMultipleSheets: false,
       supplierMergeMultipleFiles: false,
       serverPath: "",
       serverUserName: "",
       serverPassword: "",
       serverPortNumber: "",
       serverFolderPath: "",
       showModal: false,
       bulkUpload:false,
       uploadBtn:false,
       dynamicData: [{sheetName:"", hospitalCode:"", skip:false}],
       isChainPharmacy: false
     };
 
     this.onChangeSupplierName = this.onChangeSupplierName.bind(this);
     this.onChangeSupplierCode = this.onChangeSupplierCode.bind(this);
     this.onChangeDSCode = this.onChangeDSCode.bind(this);
     this.onChangeSupplierERP = this.onChangeSupplierERP.bind(this);
     this.onChangeSupplierAddress = this.onChangeSupplierAddress.bind(this);
   //  this.onChangeSupplierGST = this.onChangeSupplierGST.bind(this);
    this.onChangeSupplierCity = this.onChangeSupplierCity.bind(this);
    this.onChangeSupplierState = this.onChangeSupplierState.bind(this);
    this.onChangeSupplierZone = this.onChangeSupplierZone.bind(this);
     this.onChangeSupplierFileLocation = this.onChangeSupplierFileLocation.bind(this);
     this.onChangeSupplierMultipleSheets = this.onChangeSupplierMultipleSheets.bind(this);
     this.onChangeSupplierMergeMultipleFiles = this.onChangeSupplierMergeMultipleFiles.bind(this);
     this.onChangeServerPath = this.onChangeServerPath.bind(this);
     this.onChangeServerUserName = this.onChangeServerUserName.bind(this);
     this.onChangeServerPassword = this.onChangeServerPassword.bind(this);
     this.onChangeServerPortNumber = this.onChangeServerPortNumber.bind(this);
     this.onChangeServerFolderPath = this.onChangeServerFolderPath.bind(this);
     this.onChangeSupplierSheetName = this.onChangeSupplierSheetName.bind(this);
     this.onChangeSupplierSheetCode = this.onChangeSupplierSheetCode.bind(this);
     this.onChangeSupplierSheetSkip = this.onChangeSupplierSheetSkip.bind(this);
     this.handleAddProjectSupplierForm = this.handleAddProjectSupplierForm.bind(this);
     this.handleUpdateProjectSupplierForm = this.handleUpdateProjectSupplierForm.bind(this);
     this.handleUploadSupplierData = this.handleUploadSupplierData.bind(this);
     this.handleShowModal = this.handleShowModal.bind(this);
     this.handleCloseModal = this.handleCloseModal.bind(this);
     this.showBulkUpload = this.showBulkUpload.bind(this);
     this.showSingleCreate = this.showSingleCreate.bind(this);
     this.handleAddSheets = this.handleAddSheets.bind(this); 
     this.handledeleteSheet = this.handledeleteSheet.bind(this);
     this.onChangeIsChainPharmacy = this.onChangeIsChainPharmacy.bind(this);
   }

    
    componentDidMount() {
      if(this.props.projectSupplierId)
      this.retrieveProjectSupplierDetails();
    }

    retrieveProjectSupplierDetails(){
      //alert();
      SupplierDataService.get(this.props.projectSupplierId).then((response) => {
        var projectSupplierDetails = response.data.data;
     
        this.setState({
          supplierName: projectSupplierDetails.supplierName,
          supplierCode: projectSupplierDetails.supplierCode,
          dsCode: projectSupplierDetails.dsCode,
          supplierERP: projectSupplierDetails.supplierERP,
          supplierAddress: projectSupplierDetails.supplierAddress,
          supplierCity: projectSupplierDetails.supplierCity,
          supplierState: projectSupplierDetails.supplierState,
          supplierZone: projectSupplierDetails.supplierZone,
         // supplierGST: projectSupplierDetails.supplierGST,
          supplierFileLocation: projectSupplierDetails.supplierFileLocation,
          serverPath: projectSupplierDetails.serverPath,
          serverUserName: projectSupplierDetails.serverUserName,
          serverPassword: projectSupplierDetails.serverPassword,
          serverPortNumber: projectSupplierDetails.serverPortNumber,
          serverFolderPath: projectSupplierDetails.serverFolderPath,
          supplierMultipleSheets: projectSupplierDetails.sheets.length > 0 && projectSupplierDetails.sheets[0].sheetName != null ? true : false,
          supplierMergeMultipleFiles: projectSupplierDetails.supplierMergeMultipleFiles,
          dynamicData: projectSupplierDetails.sheets.length > 0 && projectSupplierDetails.sheets[0].sheetName != null ? projectSupplierDetails.sheets : [{sheetName:"", hospitalCode:projectSupplierDetails.supplierCode, skip:false}],
          isChainPharmacy: projectSupplierDetails.isChainPharmacy,
        });

        // console.log('supplierMultipleSheets.sheets', projectSupplierDetails.sheets);
        // console.log('supplierMultipleSheets', projectSupplierDetails.sheets.length >= 1);
        // console.log('supplierMultipleSheets.1', projectSupplierDetails.sheets.length > 1 && projectSupplierDetails.sheets[0].sheetName != null ? true : false);
        // console.log('dynamicData', projectSupplierDetails.sheets.length > 1 && projectSupplierDetails.sheets[0].sheetName != null ? projectSupplierDetails.sheets : [{sheetName:"", hospitalCode:projectSupplierDetails.supplierCode, skip:false}]);
  
      });
    }

   onChangeSupplierName(e) {
		this.setState({
			supplierName: e.target.value,
		});
	}

  onChangeSupplierCode(e) {
		this.setState({
			supplierCode: e.target.value,
		});
	}

  onChangeDSCode(e) {
    console.log('onChangeDSCode', e.target.value);
		this.setState({
			dsCode: e.target.value,
		});
	}

  onChangeSupplierERP(e) {
		this.setState({
			supplierERP: e.target.value,
		});
	}


  onChangeSupplierAddress(e) {
    this.setState({
			supplierAddress: e.target.value,
		});
  }

  onChangeSupplierCity(e) {
		this.setState({
			supplierCity: e.target.value,
		});
	}

  onChangeSupplierState(e) {
		this.setState({
			supplierState: e.target.value,
		});
	}

  onChangeSupplierZone(e) {
		this.setState({
			supplierZone: e.target.value,
		});
	}

  // onChangeSupplierGST(e) {
	// 	this.setState({
	// 		supplierGST: e.target.value,
	// 	});
	// }

  onChangeSupplierFileLocation(e) {
   	this.setState({
			supplierFileLocation: e,
		});
	}

  onChangeIsChainPharmacy(value) {
    console.log('onChangeIsChainPharmacy', value);
    this.setState({ isChainPharmacy: value });
 }

  onChangeSupplierMultipleSheets(e) {
    const { dynamicData } = this.state;
    this.setState({
      dynamicData : dynamicData,
      supplierMultipleSheets: e,
    });
  }

  onChangeSupplierMergeMultipleFiles(value) {
    console.log('onChangeSupplierMergeMultipleFiles', value);
    this.setState({ supplierMergeMultipleFiles: value });
  }

  onChangeServerPath(e) {
		this.setState({
			serverPath: e.target.value,
		});
	}

  onChangeServerUserName(e) {
		this.setState({
			serverUserName: e.target.value,
		});
	}

  onChangeServerPassword(e) {
		this.setState({
			serverPassword: e.target.value,
		});
	}

  onChangeServerPortNumber(e) {
		this.setState({
			serverPortNumber: e.target.value,
		});
	}

  onChangeServerFolderPath(e) {
		this.setState({
			serverFolderPath: e.target.value,
		});
	}

  onChangeSupplierSheetName(e,index) {
    const { dynamicData } = this.state;
    dynamicData[index].sheetName = e.target.value;
    this.setState({
      dynamicData : dynamicData
    });
  }

  onChangeSupplierSheetCode(e,index) {
    const { dynamicData } = this.state;
    dynamicData[index].hospitalCode = e.target.value;
    this.setState({
      dynamicData : dynamicData
    });
  }

  onChangeSupplierSheetSkip(e,index) {
    const { dynamicData } = this.state;
    dynamicData[index].skip = e;
    this.setState({
      dynamicData : dynamicData
    });
  }
  
  handleShowModal() {
    this.setState({
      showModal: true,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false, 
    });
  }

  showBulkUpload() {
    this.setState({
      bulkUpload: true, 
    });
  }

  showSingleCreate() {
    this.setState({
      bulkUpload: false, 
    });
  }

  handleAddProjectSupplierForm() {

    var data = {
       projectId:this.props.projectId,
       supplierName: this.state.supplierName,
       supplierCode: this.state.supplierCode,
       dsCode: this.state.dsCode,
       supplierERP:this.state.supplierERP,
       supplierAddress:this.state.supplierAddress,
       supplierCity:this.state.supplierCity,
       supplierState:this.state.supplierState,
       supplierZone:this.state.supplierZone,
       //supplierGST: this.state.supplierGST,
       supplierFileLocation: this.state.supplierFileLocation,
       serverPath: this.state.serverPath,
       serverUserName: this.state.serverUserName,
       serverPassword: this.state.serverPassword,
       serverPortNumber: this.state.serverPortNumber,
       serverFolderPath: this.state.serverFolderPath,
       supplierMergeMultipleFiles: this.state.supplierMergeMultipleFiles,
       sheets: this.state.supplierMultipleSheets ? this.state.dynamicData : [{"sheetName": null,"hospitalCode": this.state.supplierCode,"skip": false}],
       isChainPharmacy: this.state.isChainPharmacy
    }
    AppActions.setLoading(true);
		SupplierDataService.create(data)
			.then((response) => {
        AppActions.setLoading(false);
	      if(response.data.success){ // check for success
          var notify_message =({
            type:"success",
            message:"Supplier has been created successfully."
          });
          nav_actions.setSideNav(nav_store.dispatch, {});
          this.props.redirectToViewProjectSupplier("/project/" + this.props.projectId + "/supplier",notify_message);
        }else{
          if(response.data.err.message){ // fields error
            var notify_message =({
              type:"error",
              message:response.data.err.message
            });
          }
          else{ // mongo error
            var notify_message =({ 
              type:"error",
              message:response.data.err.name + " - May be duplicate Supplier code."
            });
          }
          this.notify(notify_message.type,notify_message.message);
        }
   		})
      
	}

  handleUpdateProjectSupplierForm() {

    
    var data = {
       projectId:this.props.projectId,
       supplierName: this.state.supplierName,
       supplierCode: this.state.supplierCode,
       dsCode: this.state.dsCode,
       supplierERP:this.state.supplierERP,
       supplierAddress:this.state.supplierAddress,
       supplierCity:this.state.supplierCity,
       supplierState:this.state.supplierState,
       supplierZone:this.state.supplierZone,
      // supplierGST: this.state.supplierGST,
       supplierFileLocation: this.state.supplierFileLocation,
       serverPath: this.state.serverPath,
       serverUserName: this.state.serverUserName,
       serverPassword: this.state.serverPassword,
       serverPortNumber: this.state.serverPortNumber,
       serverFolderPath: this.state.serverFolderPath,
       supplierMergeMultipleFiles: this.state.supplierMergeMultipleFiles,
       sheets: this.state.supplierMultipleSheets ? this.state.dynamicData : [{"sheetName": null,"hospitalCode": this.state.supplierCode,"skip": false}],
       isChainPharmacy: this.state.isChainPharmacy
    }
    console.log(data);
    AppActions.setLoading(true);
		SupplierDataService.update(this.props.projectSupplierId, data)
    .then((response) => {
      AppActions.setLoading(false);
      if(response.data.success){ // check for success
        var notify_message =({
          type:"success",
          message:"Supplier has been created successfully."
        });
        this.props.redirectToViewProjectSupplier("/project/" + this.props.projectId + "/supplier",notify_message);
      }else{
        if(response.data.err.message){ // fields error
          var notify_message =({
            type:"error",
            message:response.data.err.message
          });
        }
        else{ // mongo error
          var notify_message =({ 
            type:"error",
            message:response.data.err.name + " - May be duplicate Supplier code."
          });
        }
        this.notify(notify_message.type,notify_message.message);
      }
     
    })
   
	}

  handleAddSheets() {
    this.setState({
      dynamicData: [...this.state.dynamicData, { sheetName: "", hospitalCode: "", skip: false }]
    })
  }

  handledeleteSheet(index) {
    console.log(index);
    const list = [...this.state.dynamicData];
    list.splice(index, 1);
    this.setState({
      dynamicData: list
    });
  }

  getFileExtension(name) {
    const parts = name.split('.');

    if (parts.length > 0) {
        return parts.pop();
    }

    return false;
  }

  isValidExtension(name) {
      const extension = this.getFileExtension(name);
      return extension;
      //return extension && extension.indexOf('xls') >= 0;
  }

  readFile(e) {
   // alert()
    const { target } = e;
    let file = null;

    if (target.files && target.files.length > 0) {
        file = target.files[0];
        if (!this.isValidExtension(file.name)) {
            return;
        }
    }
    
    this.setState({ file : file, uploadBtn : true });
    AppActions.setLoading(true);
    //this.setState({ file, sourceTargetColumnMapping: [] });

    this.proccessFile(file)
}

async proccessFile(file) {

  if(!file) return;
  this.setState({
    fileUploaded:true,
  });
  const { setRows } = this.props;
  var reader = new FileReader();
  // reader.onload = this.excelToJson.bind(this,reader, file);
  // reader.readAsBinaryString(file);

  if (reader.readAsBinaryString) {
      reader.onload = async(e) => {
          this.processExcel(reader.result);
      };
      reader.readAsBinaryString(file);
  }
  
}


processExcel(data){
  var workbook = XLSX.read(data, {
    type: 'binary'
  })

  var sheet_name_list = workbook.SheetNames;

  var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
  var data = XLSX.utils.sheet_to_json(first_worksheet, {
    header: 1,
    // blankCell : true,
    // defval: null
  }); 
  
  data.splice(0, 1);
  this.setState({
    rows:data
  })
  var supplierDataDoc = [];
  var supplierData = data.map(item => ({
    projectId:this.props.projectId,
    supplierName: item[1],
    supplierCode: item[0],
    supplierERP: item[2],
    supplierAddress: item[3],
  //  supplierGST : item[3],
    supplierCity: item[4],
    supplierState: item[5],
    supplierZone: item[6],
    supplierFileLocation : item[7],
    serverPath : item[8],
    serverUserName : item[9],
    serverPassword : item[10],
    serverPortNumber : item[11],
    serverFolderPath : item[12]
  })
  )
 // supplierDataDoc.push(supplierData);
 
  AppActions.setLoading(false);
  
}

handleUploadSupplierData() {
  var data = this.state.rows;
  var supplierData = data.map(item => ({
    projectId:this.props.projectId,
    supplierName: item[1],
    supplierCode: item[0],
    supplierERP: item[2],
    supplierAddress: item[3],
  //  supplierGST : item[3],
    supplierCity: item[4],
    supplierState: item[5],
    supplierZone: item[6],
    supplierFileLocation : item[7],
    serverPath : item[8],
    serverUserName : item[9],
    serverPassword : item[10],
    serverPortNumber : item[11],
    serverFolderPath : item[12],
  })
  )
 // supplierDataDoc.push(supplierData);
  AppActions.setLoading(true);
  SupplierDataService.createBulk(supplierData)
    .then((response) => {
      AppActions.setLoading(false);
      if(response.data.success){ // check for success
        var notify_message =({
          type:"success",
          message:"Supplier has been created successfully."
        });
        nav_actions.setSideNav(nav_store.dispatch, {});
        this.props.redirectToViewProjectSupplier("/project/" + this.props.projectId + "/supplier",notify_message);
      }else{
        if(response.data.err){ // fields error
          var notify_message =({
            type:"error",
            message:response.data.error.writeErrors.errmsg
          });
        }
        else{ // mongo error
          var notify_message =({ 
            type:"error",
            message: response.data.error.result.nInserted+" Records Inserted . "+response.data.error.writeErrors[0].errmsg + " - May be duplicate Supplier code."
          });
        }
        this.notify(notify_message.type,notify_message.message);
      }
    })
}

//this is for showing notification
notify(type, message) {
  toast(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    type: type,
  });
}

  
  render() {
    const {
      showModal,
      bulkUpload,
      uploadBtn
      } = this.state;
    const {
      projectId,
      projectSupplierId
    } = this.props;
    return (

      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">
          {projectSupplierId ? "Edit Project Supplier Configuration" : "Create New Project Supplier Configuration" }
            {!bulkUpload ? <Button
                className="ml-3"
                variant="primary"
                onClick={this.showBulkUpload}
              >
                <FcPlus /> Bulk Import
              </Button>
             :
              <Button
                className="ml-3"
                variant="primary"
                onClick={this.showSingleCreate}
              >
                <FcPlus /> Single Create
              </Button>
            }
            <Link className="btn btn-primary ml-4" to={"/project/"+projectId+"/supplier"}><FcAcceptDatabase /> View All</Link>
          </h6>
     
        </CardHeader>
        <ListGroup flush>
          <ListGroupItem className="">
            {!bulkUpload &&
            <Form>
              <Row form>
                {/* First Name */}
                <Col md="12" className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierName">{SPAIN ? 'Hospital Name' : 'Supplier Name'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierName"
                            placeholder="Supplier Name"
                            value={this.state.supplierName}
											      onChange={this.onChangeSupplierName}
                          />
                        </Col>
                    </Row>

                    <Row className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierCode">{SPAIN ? 'Hospital Code' : 'Supplier Code'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierCode"
                            placeholder="Supplier Code"
                            value={this.state.supplierCode}
											      onChange={this.onChangeSupplierCode}
                          />
                        </Col>
                    </Row>

                    {SAUDI && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="dsCode">DS Code</label></Col>
                        <Col className="form-field" md="8">
                          <FormInput
                              id="dsCode"
                              placeholder="DS Code"
                              value={this.state.dsCode}
                              onChange={this.onChangeDSCode}
                            />
                          </Col>
                      </Row>
                    )}
                    
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierERP">{SPAIN ? 'Hospital ERP' : 'Supplier ERP'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierERP"
                            placeholder="Supplier ERP"
                            value={this.state.supplierERP}
											      onChange={this.onChangeSupplierERP}
                          />
                        </Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierAddress">{SPAIN ? 'Hospital Address' : 'Supplier Address'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierAddress"
                            placeholder="Supplier Address"
                            value={this.state.supplierAddress}
											      onChange={this.onChangeSupplierAddress}
                          />
                        </Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierCity">{SPAIN ? 'Hospital City' : 'Supplier City'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierCity"
                            placeholder="Supplier City"
                            value={this.state.supplierCity}
											      onChange={this.onChangeSupplierCity}
                          />
                        </Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierState">{SPAIN ? 'Hospital State' : 'Supplier State'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierState"
                            placeholder="Supplier State"
                            value={this.state.supplierState}
											      onChange={this.onChangeSupplierState}
                          />
                        </Col>
                    </Row>
                    <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierZone">{SPAIN ? 'Hospital Zone' : 'Supplier Zone'}</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierZone"
                            placeholder="Supplier Zone"
                            value={this.state.supplierZone}
											      onChange={this.onChangeSupplierZone}
                          />
                        </Col>
                    </Row>
                    {SPAIN && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierMultipleSheets">Allow Multiple Sheets</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={this.state.supplierMultipleSheets}
                            id="supplierMultipleSheets"
                            onlabel='Yes'
                            offlabel='No'
                            onChange={this.onChangeSupplierMultipleSheets}
                          />
                          {this.state.supplierMultipleSheets &&
                            <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleAddSheets}><FcPlus size="20"/> Add Sheets </Button>
                          }
                          {this.state.supplierMultipleSheets && this.state.dynamicData.map((item, index) => {
                            return (
                              <Row key={index}>
                                <Col className="form-field" md="4">
                                  <FormInput
                                    id="supplierSheetName"
                                    placeholder="Sheet Name"
                                    value={item.sheetName}
                                    onChange={(e) => this.onChangeSupplierSheetName(e, index)}
                                  />
                                </Col>
                                <Col className="form-field" md="4">
                                  <FormInput
                                    id="supplierSheetCode"
                                    placeholder="Sheet Code"
                                    value={item.hospitalCode}
                                    onChange={(e) => this.onChangeSupplierSheetCode(e, index)}
                                  />
                                </Col>
                                <Col className="form-field" md="4">
                                  <label htmlFor="supplierSheetSkip" className="mr-1">Skip</label>
                                  <BootstrapSwitchButton
                                    checked={item.skip}
                                    id="supplierSheetSkip"
                                    onlabel='Yes'
                                    offlabel='No'
                                    onChange={(e) => this.onChangeSupplierSheetSkip(e, index)}
                                  />
                                  <span className="text-danger cursor-pointer ml-3" title="delete" onClick={() => this.handledeleteSheet(index)}><TiDeleteOutline size="30" /></span>
                                </Col>                              
                              </Row>
                            )
                          })
                          }
                        </Col>
                      </Row> 
                    )}
                    {SAUDI && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierMultipleSheets">Allow Multiple Sheets</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={this.state.supplierMultipleSheets}
                            id="supplierMultipleSheets"
                            onlabel='Yes'
                            offlabel='No'
                            onChange={this.onChangeSupplierMultipleSheets}
                          />
                          {this.state.supplierMultipleSheets &&
                            <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleAddSheets}><FcPlus size="20"/> Add Sheets </Button>
                          }
                          {this.state.supplierMultipleSheets && this.state.dynamicData.map((item, index) => {
                            return (
                              <Row key={index}>
                                <Col className="form-field" md="4">
                                  <FormInput
                                    id="supplierSheetName"
                                    placeholder="Sheet Name"
                                    value={item.sheetName}
                                    onChange={(e) => this.onChangeSupplierSheetName(e, index)}
                                  />
                                </Col>
                                <Col className="form-field" md="4">
                                  <FormInput
                                    id="supplierSheetCode"
                                    placeholder="Sheet Code"
                                    value={item.hospitalCode}
                                    onChange={(e) => this.onChangeSupplierSheetCode(e, index)}
                                  />
                                </Col>
                                <Col className="form-field" md="4">
                                  <label htmlFor="supplierSheetSkip" className="mr-1">Skip</label>
                                  <BootstrapSwitchButton
                                    checked={item.skip}
                                    id="supplierSheetSkip"
                                    onlabel='Yes'
                                    offlabel='No'
                                    onChange={(e) => this.onChangeSupplierSheetSkip(e, index)}
                                  />
                                  <span className="text-danger cursor-pointer ml-3" title="delete" onClick={() => this.handledeleteSheet(index)}><TiDeleteOutline size="30" /></span>
                                </Col>                              
                              </Row>
                            )
                          })
                          }
                        </Col>
                      </Row> 
                    )}
                    {(SPAIN || SAUDI)  && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="supplierMergeMultipleFiles">Allow Merging Multiple Files</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={this.state.supplierMergeMultipleFiles}
                            id="supplierMergeMultipleFiles"
                            onlabel='Yes'
                            offlabel='No'
                            onChange={this.onChangeSupplierMergeMultipleFiles}
                          />
                        </Col>
                      </Row>
                    )} 
                    {SAUDI && (
                      <Row className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="isChainPharmacy">Is Chain Pharmacy Data</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={this.state.isChainPharmacy}
                            id="isChainPharmacy"
                            onlabel='Yes'
                            offlabel='No'
                            onChange={this.onChangeIsChainPharmacy}
                          />
                        </Col>
                      </Row>
                    )}                 
                    {/* <Row  className="form-group-row">
                      <Col className="form-label" md="4"><label htmlFor="supplierGST">Supplier GST Number</label></Col>
                      <Col className="form-field" md="8">
                        <FormInput
                            id="supplierGST"
                            placeholder="Supplier GST Number"
                            value={this.state.supplierGST}
											      onChange={this.onChangeSupplierGST}
                          />
                        </Col>
                    </Row> */}
                    {INDIA && (
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="onChangeSupplierFileLocation">Supplier File Location</label></Col>
                        <Col className="form-field" md="8">
                          <BootstrapSwitchButton
                            checked={this.state.supplierFileLocation}
                            id="supplierFileLocation"
                            onlabel='Yes'
                            offlabel='No'
                            onChange={this.onChangeSupplierFileLocation}
                          />
                        </Col>
                      </Row>
                    )}
                    {this.state.supplierFileLocation && (
                      <>
                      <Row  className="form-group-row">
                        <Col className="form-label" md="4"><label htmlFor="fileLocationConfiguration">File Location Configuration</label></Col>
                        <Col className="form-field" md="8">
                          <Row>
                            <Col className="form-field" md="9"> 
                              <FormInput
                              id="serverPath"
                              placeholder="Server Path"
                              value={this.state.serverPath}
                              onChange={this.onChangeServerPath}
                              />
                            </Col>
                            <Col className="form-field" md="3"> 
                              <FormInput
                                id="serverPortNumber"
                                placeholder="Port"
                                value={this.state.serverPortNumber}
                                onChange={this.onChangeServerPortNumber}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="form-field" md="6"> 
                              <FormInput
                                id="serverUsername"
                                placeholder="Server User Name"
                                value={this.state.serverUserName}
                                onChange={this.onChangeServerUserName}
                              />
                            </Col>
                            <Col className="form-field" md="6"> 
                              <FormInput
                                id="serverPassword"
                                placeholder="Server Password"
                                value={this.state.serverPassword}
                                onChange={this.onChangeServerPassword}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="form-field" md="12"> 
                              <FormInput
                                id="folderPath"
                                placeholder="Folder Path"
                                value={this.state.serverFolderPath}
                                onChange={this.onChangeServerFolderPath}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                    )}
                    <Row  className="form-group-row">
                      <Col className="form-button" md="4">
                        {projectSupplierId ? 
                          <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleUpdateProjectSupplierForm}><FcPlus /> {SPAIN ? 'Update Hospital' : 'Update Supplier'} </Button>
                          :
                          <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleAddProjectSupplierForm}><FcPlus /> {SPAIN ? 'Create Hospital' : 'Create Supplier'} </Button>
                        }
                      </Col>
                    </Row>
                </Col>
              </Row>
            </Form>
           }
            {bulkUpload &&  
          <Form>
            <Row form>
              <Col md="12" className="form-group">
                <div><a className="btn btn-primary mb-4 ml-4" href={file} download><FcDownload /> Download Sample File</a></div>
                <Row className="form-group-row">
                  <Col className="form-label" md="4">
                    <label htmlFor="feFirstName">Select Excel File</label>
                  </Col>
                  <Col className="form-field" md="8">
                    <div className="custom-file mb-3">
                      <input 
                          type="file" 
                          className="custom-file-input" 
                          id="file" 
                          name="file"
                          placeholder="Upload your excel file"
                          onChange={this.readFile.bind(this)}
                      />
                      <label className="custom-file-label" htmlFor="customFile2">
                        Choose file...
                      </label>
                    </div>
                  </Col>
                </Row>
                {uploadBtn && (
                <Row  className="form-group-row">
                  <Col className="form-button" md="4">
                      <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleUploadSupplierData}><FcPlus /> Upload Supplier Data </Button>
                  </Col>
                </Row>
                )}
                </Col>
              </Row>
            </Form>
          }
          </ListGroupItem>
        </ListGroup>
          
        <Container>
            <Row>
                <TableRow
                    rows={this.state.rows ? this.state.rows : ""}
                />
            </Row>
        </Container>

        {/* <Modal show={showModal} size="lg" onHide={this.handleCloseModal}>
          <Modal.Header>
            <Modal.Title>Bulk Import</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.handleCloseModal}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body> */}
         
          {/* </Modal.Body>
        </Modal> */}
        <ToastContainer />                 
      </Card>
    )
  }
}

export default CreateProjectSupplierConfig;
